export interface Labels {
  en_US: string,
  nb_NO: string,
};
export interface Registration{
  id: string;
  display_labels: Labels;
  display_label: string;
  descriptions: object;
  status: string;
  default_locale: string;
  timezone: string;
  create_dttm: string;
  update_dttm: string;
  last_status_update: string;
  discontinue_dttm: string;
  updated_by: string;
  alternate_ids: object;
  product_id: string;
  program_id: string;
  portfolio_id: string;
  flexible_asset_id: string;
  registration_identifier: object;
  groups_zones_divisions: string;
  utility_service_account_number: string;
  transmission_distribution_company: string;
  energy_supplier: string;
  effective_dttm: string;
  termination_dttm: string;
  drop_to_value: number;
  drop_by_value: number;
  baseline_value: number;
  minimum_value: number;
  maximum_value: number;
  percent_change: number;
  approved_by_customer: boolean;
  approved_by_customer_dttm: string;
  approved_by_enelx: boolean;
  approved_by_enelx_dttm: string;
  nomination_offset: number;
  customer_read_only: boolean;
  event_advance_notice: number;
  min_event_duration: number;
  locked_out: boolean;
  control_timeout_override: number;
  preauthorized: boolean;
  control_type: string;
  dispatch_conf: DispatchConf;
  registration_type: RegistrationType;
  control_time_override: number;
  ranking_preference: number;
  offer_dimension: string;
  baseline_adjustment_capability: number;
  max_hours_per_day: number;
  energy_reduction_plan: string;
  project_manager_name: string;
  account_manager_name: string;
}
export interface DispatchConf{
  anticipated_kw: number;
  estimate_performance_ind: boolean;
  max_hours_per_season: number;
  max_consecutive_days: number;
  max_consecutive_hours: number;
  max_events_per_season: number;
  minutes_between_events: number;
}
export enum RegistrationType {
  LOAD = 'LOAD',
  GENERATOR = 'GENERATOR',
  STORAGE = 'STORAGE',
  DEMAND_ON = 'DEMAND_ON',
  LOAD_METERED_GENERATOR = 'LOAD_METERED_GENERATOR',
  LOAD_DROP_TO = 'LOAD_DROP_TO',
  HYBRID = 'HYBRID',
  GENERATOR_TARGET = 'GENERATOR_TARGET',
  INVERSE_GENERATOR_TARGET = 'INVERSE_GENERATOR_TARGET',
}